import { render, staticRenderFns } from "./ViewArticleLicence.vue?vue&type=template&id=6b8ad8f9&"
import script from "./ViewArticleLicence.vue?vue&type=script&lang=ts&"
export * from "./ViewArticleLicence.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports